import { Dropdown, Icon } from '@wyz/ui';
import { LocalStorageStore } from '@wyz/utils';
import { useAuth } from 'react-oidc-context';
import { Link } from 'react-router';
import { Trans, useConfig } from '~/common/context';
import { log } from '~/common/helpers';
import { SESSION_LS_KEYS } from '~/purchase/helpers';

const ProfileDropdown = () => {
  const auth = useAuth();
  const config = useConfig();
  const logout = () => {
    Object.values(SESSION_LS_KEYS).forEach((key) =>
      LocalStorageStore.remove(key),
    );
    auth
      .signoutRedirect({
        post_logout_redirect_uri: config.baseAppUrl,
      })
      .catch((error: Error) => {
        log(error);
      });
  };

  return (
    <Dropdown.Container navbar={true} as='li'>
      <Dropdown.Toggle
        id='profile-toggler'
        bsPrefix='toggle'
        as={Link}
        to='#!'
        className='p-0 nav-link d-flex align-items-center'
      >
        <Icon icon='account-circle' size='lg' />
      </Dropdown.Toggle>
      <Dropdown.Menu className='dropdown-caret dropdown-menu-card  dropdown-menu-end'>
        <Dropdown.ItemText>
          {auth.user?.profile.family_name} {auth.user?.profile.given_name}
        </Dropdown.ItemText>
        <div className='bg-white rounded-2 py-2 dark__bg-1000'>
          <Dropdown.Item as='div' role='button' onClick={logout} id='logout'>
            <Trans i18nKey='app.common.navbar.top.profile_dropdown.logout' />
          </Dropdown.Item>
        </div>
      </Dropdown.Menu>
    </Dropdown.Container>
  );
};

export default ProfileDropdown;
